import React, { useState, useEffect } from 'react';
import ReactHtmlParser, {transform, processNodes, convertNodeToElement} from 'react-html-parser';


function ParserTemplComponentsAppList(props) {
    const properties = props
    const html = properties.code
    return (
        <React.Fragment>
            {
                ReactHtmlParser(html, {
                    transform(node, index) {
                    }
                })
            }
        </React.Fragment>
    )
}

export default ParserTemplComponentsAppList